import { getEventEmitter } from '@flixbus/transclusion-eventing';

export const EVENT_SEARCH_MASK_DELETE_RETURN_CLICK = 'search.search-mask.delete_return.click';

export const emitSearchMaskDeleteReturnClickEvent = () => {
  getEventEmitter().emit(EVENT_SEARCH_MASK_DELETE_RETURN_CLICK);
};
